<template>
  <div>
    <h1>Profile</h1>
    <table>
      <tr>
        <th>Num</th>
        <th>Date</th>
        <th>Name</th>
        <th>Remove</th>
      </tr>
      <tr v-for="(session, i) in getSessions" :key="i">
        <td>{{ i + 1 }}</td>
        <td>{{ session.date | date("datetime") }}</td>
        <td>{{ session.name }}</td>
        <button @click="removeSession(session.id)">remove</button>
      </tr>
    </table>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  computed: {
    ...mapGetters(["getSessions"])
  },
  methods: {
    ...mapActions(["removeSession"])
  },
  async mounted() {
    this.$store.dispatch("getSessions");
  }
};
</script>
